
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiObjectLagan as ObiObjectLaganElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-object-lagan.js';
 
 
 

 
 export const ObiObjectLagan = createComponent({
   react: React,
   tagName: 'obi-object-lagan',
   elementClass: ObiObjectLaganElement,
   events: {
     
   }
  });
 
 